<script>
import { tableRelevant } from "@/pages/projectImpl/js/utils";

export default {
  name: "TrainReportThird",
  inject: {
    view: { default: false },
  },
  data() {
    return {
      columns: [
        { title: "能力类型", dataIndex: "abilityTypeName" },
        { title: "一级能力", dataIndex: "firstAbilityName" },
        { title: "算分开关", scopedSlots: { customRender: "score" } },
      ],
      table: tableRelevant.call(this),
      generateLoading: false,
    };
  },
  mounted() {
    this.getAbility();
  },
  methods: {
    getAbility() {
      this.$http.ReportService.GroupTrainingReportAbilityConfig(this.$store.getters["organization/getReportInfo"].id).then((res) => {
        if (this.$store.getters["organization/getReportInfo"].isAllChecked) {
          this.table.tableDataSource = res.data.map(s => {
            s.isChecked = true;
            return s;
          });
          return;
        }
        this.table.tableDataSource = res.data;
      });
    },
    generateReport() {
      const Params = {
        "id": this.$store.getters["organization/getReportInfo"].id,
        "firstAbilityIds": this.table.tableDataSource.filter(s => s.isChecked).map(s => s.firstAbilityId),
      };
      this.generateLoading = true;
      this.$http.ReportService.GroupTrainingReportAbility(Params).then((res) => {
        return this.$http.ReportService.GroupTrainingReportGenerate(Params.id);
      }).then((res) => {
        this.$message.success(res.message);
        this.$bus.$emit("closeCreateReport");
      }).finally(() => {
        this.generateLoading = false;
      });
    },
  },
};
</script>

<template>
  <div>
    <div class="header">
      <b>机构名称：</b> {{ $store.getters["organization/getReportInfo"].organizationName }}
      <b style="margin-left: 50px;">课程名称：</b> {{ $store.getters["organization/getReportInfo"].courseName }}
    </div>
    <a-table :columns="columns"
             :pagination="table.tablePagination"
             :loading="table.tableLoading"
             :dataSource="table.tableDataSource">
      <div slot="score" slot-scope="text">
        <a-switch v-model="text.isChecked" checked-children="开" un-checked-children="关" :disabled="view" />
      </div>
    </a-table>

    <div v-if="!view" style="text-align: right; margin: 30px 0; padding-right: 50px">
      <a-button @click="$parent.$data.current = 1" style="margin-right: 20px">上一步</a-button>
      <a-button type="primary" :loading="generateLoading" @click="generateReport">生成报告</a-button>
    </div>
  </div>
</template>

<style scoped lang="less">
.header {
  margin-bottom: 24px;
}
</style>
